export { CartItemAdditionalInformation } from './cart-item-additional-information';
